$(document).mouseup(esconderMenu);

$(document).ajaxComplete(function (event, xhr, settings) {

    if (settings.url.indexOf('ItensOrcamento') !== -1) {
        AsideDireita.mostrarMenuOrcamento();

    } else if (settings.url.indexOf('Cliente/Pesquisar') !== -1) {
        AsideDireita.ocultarMenuCliente(); // manut-199
    } else if (settings.url.indexOf('AtualizarCliente') !== -1 || settings.url.indexOf('Cliente/Pesquisar') !== -1) {
        AsideDireita.mostrarMenuCliente(); // manut-199
    } else if (settings.url.indexOf('PesquisarOrcamento') !== -1 || window.location.href.indexOf('PesquisaOrcamento') !== -1) {
        AsideDireita.mostrarPesquisaOrcamento();

    } else if (window.location.href.indexOf('Produto/Pesquisar') !== -1) {
        AsideDireita.mostrarPesquisaProduto();
    }
});

function esconderMenu(e) {
    var $menu = $("#menu");
    var $triggerMenu = $("#abrirMenuPrincipal");

    if (!$triggerMenu.is(e.target) && !$menu.is(e.target) && $menu.has(e.target).length === 0) {
        $menu.addClass("none");
        $triggerMenu.removeClass("ativo");
    }
}

window.esconderMenu = esconderMenu

function menu(a) {
    a.classList.toggle("ativo");
    document.getElementById("menu").classList.toggle("none");
}

window.menu = menu

function aside(a) {
    a.classList.toggle("ativo");
    document.getElementsByTagName("aside")[0].classList.toggle("none");
}

window.aside = aside

function selecionarTodos(a) {
    
}

window.selecionarTodos = selecionarTodos

function mostrarAjudaRecalcularParcela() {
    global.showInfoMessage("Quando campo \"Recalcular Parcelas\" estiver DESMARCADO:<br><ul><li>- A alteração do valor de uma parcela para cima ou para baixo não irá alterar o valor das demais parcelas.</li></ul><p><br>" +
        "Quando campo \"Recalcular Parcelas\" estiver MARCADO:<br><ul><li>- Ao alterar o valor da ENTRADA tanto para cima quanto para baixo, o valor das demais parcelas será igualado, considerando a alteração do valor da entrada.</li><br>" +
        "<li>- Apenas a última parcela é passível de alteração, para um valor MENOR.</li><br><li>- Ao alterar o valor da última parcela para um valor menor, será criada nova parcela com o valor deduzido da última parcela.</li></ul>");
}

window.mostrarAjudaRecalcularParcela = mostrarAjudaRecalcularParcela

function AtivarDesativarLogs() { // FNX-3163
    var self = this;

    global.ajax({
        url: "/Comum/AtivarDesativarLogs",
        type: "post",
        contentType: "application/json",
        success: function (data) { 

            if (data == 0) {
                return;
            } else if (data == 1) {
                global.showInfoMessage("Log de Mark Up ATIVADO. <br>Os demais foram DESATIVADOS.");
            } else if (data == 2) {
                global.showInfoMessage("Log de SQL ATIVADO. <br>Os demais foram DESATIVADOS.");
            } else if (data == 3){
                global.showInfoMessage("Todos os logs foram DESATIVADOS.");
            } else {
                return;
            }
        }
    });
}

window.AtivarDesativarLogs = AtivarDesativarLogs

function limparSelecaoEstoqueProduto() {
    $("#lista-estoque-produto-container tr", this.$el).each(function() {
        $(this).css({ "background-color": '', "color": '' });
    });
}

window.limparSelecaoEstoqueProduto = limparSelecaoEstoqueProduto

function consulta(a) {
    var consulta = document.getElementById("jmConsulta");
    a.classList.toggle("ativo");
    consulta.classList.toggle("none");
    consulta.style.left = a.offsetLeft + "px";
    consulta.style.marginTop = "-8px";
}

window.consulta = consulta

function conf(a) {
    var conf = document.getElementById("jmConf");
    conf.classList.toggle("none");
    a.classList.toggle("selecionado");
    conf.style.left = a.offsetLeft + "px";
}

window.conf = conf

function listaConf(a) {
    a.classList.toggle("icone-vazio");
}

window.listaConf = listaConf

function esconde(a) {
    a.classList.toggle("esconde");
    a.parentNode.nextElementSibling.classList.toggle("none");
}

window.esconde = esconde

function info() {
    var info = document.getElementById("jmInfo"),
        over = document.getElementById("overlay");
    info.className = "jm modal-info";
    over.className = "overlay";
}

window.info = info

function fechar() {
    var info = document.getElementById("jmInfo"),
        over = document.getElementById("overlay");
    info.className = "none";
    over.className = "none";
}

window.fechar = fechar

function toggleInfo(a) {
    a.checked = false;
    document.getElementById("maisInfo").disabled = false;
}

window.toggleInfo = toggleInfo

function check(a) {
    var b = a.getElementsByTagName("input")[0];
    if (b.checked == true) {
        b.checked = false;
    } else {
        b.checked = true;
        a.className = "selecionado";
    }
}

window.check = check

function topo() {
    var c = document.getElementById('tabela-produtos'), topo = document.getElementById('topo');
    if (topo) {
        if (document.documentElement.scrollTop <= 0) {
            topo.className = 'icone-topo none';
        } else {
            topo.className = 'icone-topo';
        }
    }
}

window.topo = topo


window.onscroll = topo;

//document.body.className = 'rodape-fixo';
//document.getElementsByTagName('h1')[0].className = 'logo-cliente2';
//document.getElementsByTagName('h1')[0].innerHTML = 'Nome da Empresa <span class="secao">Vendas</span>';

/* Layout()
 * ========
 * Implements AdminLTE layout.
 * Fixes the layout height in case min-height fails.
 *
 * @usage activated automatically upon window load.
 *        Configure any options by passing data-option="value"
 *        to the body tag.
 */
+function ($) {
    'use strict';

    var DataKey = 'lte.layout';

    var Default = {
        slimscroll: true,
        resetHeight: true
    };

    var Selector = {
        wrapper: '.wrapper',
        contentWrapper: '.content-wrapper',
        layoutBoxed: '.layout-boxed',
        mainFooter: '.main-footer',
        mainHeader: '.main-header',
        sidebar: '.sidebar-inner',
        controlSidebar: '.control-sidebar',
        fixed: '.fixed',
        sidebarMenu: '.sidebar-menu',
        logo: '.main-header .logo'
    };

    var ClassName = {
        fixed: 'fixed',
        holdTransition: 'hold-transition'
    };

    var Layout = function (options) {
        this.options = options;
        this.bindedResize = false;
        this.activate();
    };

    Layout.prototype.activate = function () {
        this.fix();
        this.fixSidebar();

        $('body').removeClass(ClassName.holdTransition);

        if (this.options.resetHeight) {
            $(Selector.wrapper).css({
                'height': 'auto',
                'min-height': '100%'
            });
            $('html, ' + Selector.wrapper).css({
                'margin': 'auto',
                'min-height': '100%'
            });
        }

        if (!this.bindedResize) {
            $(window).resize(function () {
                this.fix();
                this.fixSidebar();

                $(Selector.logo + ', ' + Selector.sidebar).one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                    this.fix();
                    this.fixSidebar();
                }.bind(this));
            }.bind(this));

            this.bindedResize = true;
        }

        $(Selector.sidebarMenu).on('expanded.tree', function () {
            this.fix();
            this.fixSidebar();
        }.bind(this));

        $(Selector.sidebarMenu).on('collapsed.tree', function () {
            this.fix();
            this.fixSidebar();
        }.bind(this));
    };

    Layout.prototype.fix = function () {
        // Remove overflow from .wrapper if layout-boxed exists
        $(Selector.layoutBoxed + ' > ' + Selector.wrapper).css('overflow', 'hidden');

        // Get window height and the wrapper height
        var footerHeight = $(Selector.mainFooter).outerHeight() || 0;
        var headerHeight = $(Selector.mainHeader).outerHeight() || 0;
        var neg = headerHeight + footerHeight;
        var windowHeight = $(window).height();
        var sidebarHeight = $(Selector.sidebar).height() || 0;

    };

    Layout.prototype.fixSidebar = function () {

        if ($(Selector.sidebar).length > 0) {
            // Make sure the body tag has the .fixed class
            if (!$('body').hasClass(ClassName.fixed)) {
                if (typeof $.fn.slimScroll !== 'undefined') {
                    $(Selector.sidebar).slimScroll({ destroy: true }).height('auto');
                }
                return;
            }

            // Enable slimscroll for fixed layout
            if (this.options.slimscroll) {
                if (typeof $.fn.slimScroll !== 'undefined') {
                    // Add slimscroll
                    $(Selector.sidebar).slimScroll({
                        height: ($(window).height() - $(Selector.mainHeader).height() - 60) + 'px'
                    });
                }
            }

        } else {
            $(Selector.contentWrapper).css('margin-left', '0px');
        }
    };

    // Plugin Definition
    // =================
    function Plugin(option) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data(DataKey);

            if (!data) {
                var options = $.extend({}, Default, $this.data(), typeof option === 'object' && option);
                $this.data(DataKey, (data = new Layout(options)));
            }

            if (typeof option === 'string') {
                if (typeof data[option] === 'undefined') {
                    throw new Error('No method named ' + option);
                }
                data[option]();
            }
        });
    }

    var old = $.fn.layout;

    $.fn.layout = Plugin;
    $.fn.layout.Constuctor = Layout;

    // No conflict mode
    // ================
    $.fn.layout.noConflict = function () {
        $.fn.layout = old;
        return this;
    };

    // Layout DATA-API
    // ===============
    $(window).on('load', function () {
        Plugin.call($('body'));
    });
}(jQuery);

